const DistManVillListInt = {
  districtsList: [],
  castesList: {},
  foreignList: {},
  qscountryUnivList: {},
  occupationList: {},
  tabValue:""
}

function FieldsReducer(state = DistManVillListInt, action) {

  switch (action.type) {
    case "SHOW_DISTRICTS":
      return { ...state, districtsList: action.payload };
    case "SHOW_FOREIGN_DETAILS":
      return { ...state, foreignList: action.payload };
    case "SHOW_UNICOUNTRY_DETAILS":
      return { ...state, qscountryUnivList: action.payload };
    case "SET_CASTE_DATA":
      return { ...state, castesList: action.payload };
    case "SHOW_OCCUPATIONS":
      return { ...state, occupationList: action.payload };
    case "SHOW_APP_TAB_VALUE":
      return { ...state, tabValue: action.payload };
    default:
      return state;
  }
}

export default FieldsReducer;
